<template>
    <div class="row text-center">
        <div class="col-12 mb-3">
            <button
                type="submit"
                name="form_action"
                value="SAVE_CHANGES"
                class="btn btn-primary w-50 mb-2"
            >
               {{ saveChangesButtonLabel }}
            </button>

            <button
                v-if="canSaveDraft"
                type="submit"
                name="form_action"
                value="SAVE_AS_DRAFT"
                class="btn btn-secondary w-50 mb-2"
            >
                Save as Draft
            </button>

            <button
                v-if="canSaveOnly"
                type="submit"
                name="form_action"
                value="SAVE_ONLY"
                class="btn btn-secondary w-50"
            >
                Save Only
            </button>

            <div class="col-12">
                <hr class="w-75">
            </div>

            <button
                v-if="canCancel"
                type="submit"
                @click="confirmCancel"
                name="form_action"
                value="CANCEL_ORDER"
                class="btn btn-danger w-50 mb-2"
            >
                Cancel Order
            </button>

            <a
                :href="route('admin.orders.index')"
                class="btn btn-secondary w-50"
            >
                Discard & Exit
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            order: {
                type: Object,
                required: true,
            }
        },

        computed: {
            canSaveDraft() {
                return !this.order.id || this.order.status === this.$root.constants.DRAFT_ORDER;
            },

            canSaveOnly() {
                return this.order.status === this.$root.constants.BUILT_ORDER;
            },

            canCancel() {
                return this.order.id && this.order.status !== this.$root.constants.DRAFT_ORDER
            },

            saveChangesButtonLabel() {
                if (this.canSaveDraft) {
                    return 'Build Order';
                }

                if (this.order.status === this.$root.constants.BUILT_ORDER) {
                    return 'Place Order';
                }

                if (this.order.status === this.$root.constants.PLACED_ORDER) {
                    return 'Ship Order';
                }

                if (this.order.status === this.$root.constants.SHIPPED_ORDER) {
                    return 'Mark as Arrived';
                }

                return 'Save Changes';
            },
        },

        methods: {
            confirmCancel(e) {
                if(confirm('Are you sure that you want to cancel this order?')) {
                    return;
                }

                e.preventDefault()
            }
        }
    }
</script>